import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft, Check, X } from "lucide-react";
import { EASE } from "./shared";

export function ContactModal({ onClose, t, rtl }) {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(false);
  const Arrow = rtl ? ArrowLeft : ArrowRight;
  const submit = async (event) => {
    event.preventDefault();
    setSending(true);
    setError(false);
    const data = Object.fromEntries(new FormData(event.target));
    try {
      const res = await fetch(`${window.VIRA_API_URL || process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      if (!res.ok) throw new Error("send failed");
      setSent(true);
    } catch {
      setError(true);
    } finally {
      setSending(false);
    }
  };
  return (
    <motion.div className="modal-backdrop" data-testid="contact-modal" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
      <motion.div className="modal" role="dialog" aria-modal="true" data-testid="contact-dialog" initial={{ opacity: 0, y: 26, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.45, ease: EASE }}>
        <button className="icon-button modal-close" onClick={onClose} aria-label="Close contact form" data-testid="close-contact-button"><X size={20} /></button>
        {!sent ? <>
          <span className="eyebrow">{t.modalEyebrow}</span>
          <h2>{t.modalH2}</h2>
          <p>{t.modalP}</p>
          <form onSubmit={submit} className="contact-form">
            <input required name="name" aria-label={t.namePh} placeholder={t.namePh} data-testid="contact-name-input" />
            <input required name="email" type="email" aria-label={t.emailPh} placeholder={t.emailPh} data-testid="contact-email-input" />
            <textarea required name="message" aria-label={t.messagePh} placeholder={t.messagePh} rows="4" data-testid="contact-message-input" />
            {error && <p className="form-error" data-testid="contact-form-error">{t.formError}</p>}
            <button className="primary-button full-width" type="submit" disabled={sending} data-testid="contact-submit-button">{sending ? t.sending : t.send} <Arrow size={16} /></button>
          </form>
        </> : <div className="success-state" data-testid="contact-success"><div className="success-icon"><Check size={28} /></div><h2>{t.successH2}</h2><p>{t.successP}</p><button className="secondary-button" onClick={onClose} data-testid="contact-done-button">{t.done}</button></div>}
      </motion.div>
    </motion.div>
  );
}
